export default "__VITE_ASSET__BD4DrH3n__"